import React, { useEffect, useRef, useState } from 'react';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useRecoilValue } from 'recoil';
import { authAtom } from '_state';
import { authUtils } from '../../utils/authUtils';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';

const columns = [{ id: 'fileName', label: '첨부파일', minWidth: 40, width: 400, align: 'left' }];

export default function MailForward(props) {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    setError,
    formState: { errors, isDirty }
  } = useForm({});

  const auth = useRecoilValue(authAtom);

  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state;
  let formData = new FormData();

  const [datas, setDatas] = useState({});
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState('');
  const [autoCompleteValue, setAutoCompleteValue] = useState([]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const handleFileDownClick = (fileName) => async (e) => {
    console.log(fileName);
    await fileDown(fileName);
  };

  const fileDown = async (params) => {
    const response = await axios.get(`/api/file-smtp`, { params: { fileName: params }, responseType: 'blob' });
    if (response.data.error) {
      console.error(response.data.error);
      alert('다운로드 실패!');
    } else {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      const fileOriginName = response.headers['content-disposition'].split('filename=')[1];
      fileLink.setAttribute('download', fileOriginName.replace(/"/g, ''));
      fileLink.setAttribute('target', '_blank');
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    }
  };

  const sendMail = async (formData, config) => {
    await axios
      .post(`/api/mail-send`, formData, config)
      .then((response) => {
        alert(response.data.message);
        navigate(`/mail`);
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const onSubmit = async (data) => {
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    };
    formData.append('createdId', auth.userid);
    formData.append('recipient', JSON.stringify(autoCompleteValue));
    formData.append('subject', datas.subject);
    formData.append('contents', content);

    sendMail(formData, config);
  };

  const getMailLogInfo = async (value) => {
    const response = await axios.get(`/api/mail-log/${id}`);
    if (response) {
      const html = typeof response.data?.html === 'string' ? response.data?.html : response.data?.html.toString();
      setDatas(response.data);
      setContent(html);
    }
  };

  useEffect(() => {
    getMailLogInfo();
  }, []);

  return (
    <Paper sx={{ p: 4, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex' }}>
        <Typography component="h2" variant="h6" color="primary" gutterBottom>
          메일 상세보기
        </Typography>
        <Box sx={{ flex: '1 1 auto' }}></Box>
        <Button sx={{ width: 200, ml: 1 }} variant="contained" color="secondary" onClick={handleBack}>
          뒤로
        </Button>
      </Box>
      <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 2 }}>
        <TextField
          disabled
          id="recipient"
          label="받는사람"
          fullWidth
          value={datas?.recipient || ''}
          error={!!errors.datas?.recipient}
          helperText={errors.datas?.recipient && errors.datas?.recipient.message}
          {...register('datas.recipient', {
            required: '받는사람을 입력해주세요.',
            maxLength: { value: 200, message: '받는사람은 200자 이하입니다.' }
          })}
          size="small"
          onChange={handleChange}
        />
        <TextField
          disabled
          id="subject"
          variant="outlined"
          label="제목"
          fullWidth
          value={datas?.subject || ''}
          error={!!errors.datas?.subject}
          helperText={errors.datas?.subject && errors.datas?.subject.message}
          onChange={handleChange}
          size="small"
          sx={{ mt: 1 }}
        />
        {!!datas.files && (
          <Box>
            <Typography sx={{ mt: 2 }}>첨부파일</Typography>
            <TableContainer component={'div'}>
              <Table size="small">
                {/* <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <>
                        <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth, width: column.width }}>
                          {column.label}
                        </TableCell>
                        <TableCell></TableCell>
                      </>
                    ))}
                  </TableRow>
                </TableHead> */}
                <TableBody>
                  {datas.files.map((row, rowIdx) => (
                    <TableRow hover key={row.id}>
                      {columns.map((col, colIdx) => (
                        <>
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {row[col.id]}
                          </TableCell>
                          <TableCell key={`row${rowIdx}-down`} align="left">
                            <IconButton aria-label="down" onClick={handleFileDownClick(row.realFileName)}>
                              <DownloadIcon />
                            </IconButton>
                          </TableCell>
                        </>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        <Box component="div" sx={{ minHeight: 400, m: 4, overflowY: 'auto' }}>
          <div dangerouslySetInnerHTML={{ __html: content }}></div>
        </Box>
        {/* <Button type="submit" sx={{ width: 200, ml: 1 }} variant="contained">
          전송
        </Button>
        <Button sx={{ width: 200, ml: 1 }} variant="contained" color="secondary" onClick={handleBack}>
          취소
        </Button> */}
      </Box>
    </Paper>
  );
}
